import request from '../../axios';

export const getListTakenLoan = async () => {
  const {data}: {data: ITakenLoan[]} = await request.get(
    '/api/v2/payment/list-taken-loan',
  );

  return data;
};
